export default function Home() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4 text-center">
      <h1 className="text-4xl font-bold mb-4">Welcome to Holidaze</h1>
      <p className="text-lg text-gray-700">Book your next venue on our page</p>
    </div>
  );
}
